module.exports = __webpack_public_path__ + "static/media/2020 - 2021 theme logo.18229078.jpg";